package com.milta.core.localization.translations.bg

import com.milta.core.localization.PackageLabelScanStrings

internal val PackageLabelScan = PackageLabelScanStrings(
    scanTitle = "Сканиране на етикет",
    analysingTitle = "Прочитане на етикета…",
    analysingSubtitle = "Търсим името, адреса и телефонния номер на получателя. Отнема само няколко секунди.",
    reviewTitle = "Потвърждение на доставката",
    deliveryDetectedLabel = "Открита доставка",
    allReadableLabel = "Всичко е четливо",
    fieldToCompleteSingularSuffix = "поле за попълване",
    fieldToCompletePluralSuffix = "полета за попълване",
    recipientNotDetectedValue = "Не разпознат",
    addressNotDetectedValue = "Не разпознат",
    phoneNotDetectedValue = "Не разпознат",
    fieldRequiredWarning = "Задължително поле за добавяне на доставката",
    recipientCorrectionPlaceholder = "Въведете получателя…",
    addressCorrectionPlaceholder = "Въведете адреса…",
    unreadableTitle = "Нечетлив етикет.",
    unreadableMessage = "Направете нова снимка, центрирана върху етикета, добре осветена и без отблясъци.",
    maxAttemptsMessage = "Попълнете тази доставка ръчно или започнете сканирането отново с нова снимка.",
)
